/* eslint-disable */
/* cityform — catalogue data (Brand v3 + v1 breadth)
   The twelve cities (with signatures) PLUS extended commissions
   from the studio archive (no signature, photo-led). */

window.CATALOG = [
  // ── The twelve · locked signatures (§3.3) ─────────────────
  {
    id: 'sheffield', name: 'Sheffield', region: 'South Yorkshire',
    type: 'City', featured: true,
    accent: 'vermilion', landmark: 'Park Hill', landmarkId: 'parkhill',
    coords: { lat: 53.3811, lng: -1.4701, ns: 'N', ew: 'W' },
    photo: 'assets/products/sheffield_wireframe.png',
    photos: ['assets/products/sheffield_wireframe.png'],
    hero_label: 'assets/products/sheffield_label.jpeg',
    blurb: 'A 9 cm crop centred on Park Hill. 1:11000 from open survey data. The Brutalist deck-access scheme above the Don, completed 1961.',
    spec: 'Park Hill renovation panels — the vermilion the modern restoration introduced.',
    price: 45, stock: 7,
  },
  {
    id: 'london', name: 'London', region: 'Greater London',
    type: 'City', featured: true,
    accent: 'cobalt', landmark: 'Underground Roundel', landmarkId: 'roundel',
    coords: { lat: 51.5074, lng: -0.1278, ns: 'N', ew: 'W' },
    photo: 'assets/products/canary_preview.png',
    photos: ['assets/products/canary_preview.png'],
    blurb: 'A 9 cm crop centred on Trafalgar. 1:11000 from open survey data. Edward Johnston\'s 1916 mark on the spine of the city.',
    spec: 'Transit cobalt — sampled from the 1933 station tile.',
    price: 45, stock: 6,
  },
  {
    id: 'bath', name: 'Bath', region: 'Somerset',
    type: 'City', featured: true,
    accent: 'saffron', landmark: 'Royal Crescent', landmarkId: 'crescent',
    coords: { lat: 51.3811, lng: -2.3590, ns: 'N', ew: 'W' },
    photo: 'assets/products/bath_preview.png',
    photos: ['assets/products/bath_on_base.png','assets/products/bath_preview.png'],
    on_base: 'assets/products/bath_on_base.png',
    blurb: 'A 9 cm crop centred on the Royal Crescent. 1:11000 from open survey data. John Wood the Younger\'s 1774 curve in honey stone.',
    spec: 'Bath stone saffron — the colour the limestone takes at four in the afternoon.',
    price: 45, stock: 5,
  },
  {
    id: 'cambridge', name: 'Cambridge', region: 'Cambridgeshire',
    type: 'City', featured: true,
    accent: 'jade', landmark: 'Mathematical Bridge', landmarkId: 'mathbridge',
    coords: { lat: 52.2043, lng: 0.1149, ns: 'N', ew: 'E' },
    photo: 'assets/products/cambridge_preview.png',
    photos: ['assets/products/cambridge_preview.png'],
    blurb: 'A 9 cm crop centred on the Backs. 1:11000 from open survey data. Queens\' College timber bridge across the Cam, 1749.',
    spec: 'College jade — punts, river verges, the lawn on King\'s.',
    price: 45, stock: 5,
  },
  {
    id: 'edinburgh', name: 'Edinburgh', region: 'Lothian',
    type: 'City', featured: true,
    accent: 'aubergine', landmark: 'Castle Rock', landmarkId: 'castle',
    coords: { lat: 55.9533, lng: -3.1883, ns: 'N', ew: 'W' },
    photo: 'assets/products/edinburgh_on_base.png',
    photos: ['assets/products/edinburgh_on_base.png','assets/products/edinburgh_preview.png'],
    blurb: 'A 9 cm crop centred on the Castle Rock. 1:11000 from open survey data. Volcanic basalt and the Royal Mile spine in measured topography.',
    spec: 'Old Town dusk — the aubergine the basalt takes at last light.',
    price: 45, stock: 3,
  },
  {
    id: 'bristol', name: 'Bristol', region: 'Avon',
    type: 'City', featured: true,
    accent: 'coral', landmark: 'Clifton Suspension', landmarkId: 'clifton',
    coords: { lat: 51.4545, lng: -2.5879, ns: 'N', ew: 'W' },
    photo: 'assets/products/liverpool_preview.png',
    photos: ['assets/products/liverpool_preview.png'],
    blurb: 'A 9 cm crop centred on the Avon Gorge. 1:11000 from open survey data. Brunel\'s 1864 suspension bridge, 76 m above the river.',
    spec: 'Harbour timber coral — the painted houses above the floating harbour.',
    price: 45, stock: 4,
  },

  // ── In development (paired) ───────────────────────────────
  {
    id: 'manchester', name: 'Manchester', region: 'Greater Manchester',
    type: 'City', featured: true,
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.4808, lng: -2.2426, ns: 'N', ew: 'W' },
    photo: 'assets/products/manchester_preview.png',
    blurb: 'A 9 cm crop centred on Castlefield. 1:11000 from open survey data. The Bridgewater junction and the Rochdale Canal.',
    spec: 'Awaiting signature assignment.',
    price: null, stock: 0, status: 'soon',
  },
  {
    id: 'liverpool', name: 'Liverpool', region: 'Merseyside',
    type: 'City', featured: true,
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.4084, lng: -2.9916, ns: 'N', ew: 'W' },
    photo: 'assets/products/liverpool_preview.png',
    blurb: 'A 9 cm crop centred on the Pier Head. 1:11000 from open survey data. The Three Graces along the Mersey.',
    spec: 'Awaiting signature assignment.',
    price: null, stock: 0, status: 'soon',
  },
  {
    id: 'oxford', name: 'Oxford', region: 'Oxfordshire',
    type: 'City', featured: true,
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 51.7520, lng: -1.2577, ns: 'N', ew: 'W' },
    photo: 'assets/products/bath_preview.png',
    blurb: 'A 9 cm crop centred on Radcliffe Square. 1:11000 from open survey data.',
    spec: 'Awaiting signature assignment.',
    price: null, stock: 0, status: 'soon',
  },
  {
    id: 'glasgow', name: 'Glasgow', region: 'Lanarkshire',
    type: 'City', featured: true,
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 55.8642, lng: -4.2518, ns: 'N', ew: 'W' },
    photo: 'assets/products/newcastle_preview.png',
    blurb: 'A 9 cm crop centred on the Merchant City. 1:11000 from open survey data.',
    spec: 'Awaiting signature assignment.',
    price: null, stock: 0, status: 'soon',
  },
  {
    id: 'york', name: 'York', region: 'North Yorkshire',
    type: 'City', featured: true,
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.9614, lng: -1.0807, ns: 'N', ew: 'W' },
    photo: 'assets/products/york_preview.png',
    blurb: 'A 9 cm crop centred on the Minster. 1:11000 from open survey data.',
    spec: 'Awaiting signature assignment.',
    price: null, stock: 0, status: 'soon',
  },
  {
    id: 'cardiff', name: 'Cardiff', region: 'Glamorgan',
    type: 'City', featured: true,
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 51.4816, lng: -3.1791, ns: 'N', ew: 'W' },
    photo: 'assets/products/durham_preview.png',
    blurb: 'A 9 cm crop centred on the Bay. 1:11000 from open survey data.',
    spec: 'Awaiting signature assignment.',
    price: null, stock: 0, status: 'soon',
  },

  // ── Commissions from the studio archive (no signature) ────
  {
    id: 'whitby', name: 'Whitby', region: 'North Yorkshire',
    type: 'Coast',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 54.4885, lng: -0.6143, ns: 'N', ew: 'W' },
    photo: 'assets/products/whitby_hero.jpg',
    photos: ['assets/products/whitby_hero.jpg','assets/products/whitby_3q.jpg','assets/products/whitby_lifestyle.jpg','assets/products/whitby_label.jpg','assets/products/whitby_on_base.png','assets/products/whitby_top.jpg'],
    blurb: 'A commission. 9 cm crop centred on the swing bridge. 1:11000 from open survey data.',
    spec: 'Studio commission · sticker bespoke to brief.',
    price: 240, stock: 1,
  },
  {
    id: 'kelham', name: 'Kelham Island', region: 'Sheffield',
    type: 'District',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.388, lng: -1.476, ns: 'N', ew: 'W' },
    photo: 'assets/products/kelham_preview.png',
    blurb: 'A commission. 9 cm crop centred on the Don meander. 1:11000 from open survey data.',
    spec: 'Studio commission.',
    price: 240, stock: 2,
  },
  {
    id: 'parkhill-district', name: 'Park Hill', region: 'Sheffield',
    type: 'District',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.382, lng: -1.456, ns: 'N', ew: 'W' },
    photo: 'assets/products/parkhill_preview.png',
    blurb: 'A commission. 9 cm crop centred on the flats. 1:11000 from open survey data.',
    spec: 'Studio commission.',
    price: 240, stock: 3,
  },
  {
    id: 'scafell', name: 'Scafell Pike', region: 'Cumbria',
    type: 'Topography',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 54.454, lng: -3.211, ns: 'N', ew: 'W' },
    photo: 'assets/products/scafell_preview.png',
    blurb: 'A commission. 9 cm crop centred on the summit. 1:11000, 1× exaggeration.',
    spec: 'Topographic commission.',
    price: 240, stock: 2,
  },
  {
    id: 'mamtor', name: 'Mam Tor', region: 'Derbyshire',
    type: 'Topography',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.350, lng: -1.812, ns: 'N', ew: 'W' },
    photo: 'assets/products/mamtor_preview.png',
    blurb: 'A commission. 9 cm crop centred on Winnats Pass. 1:11000.',
    spec: 'Topographic commission.',
    price: 240, stock: 4,
  },
  {
    id: 'helvellyn', name: 'Helvellyn', region: 'Cumbria',
    type: 'Topography',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 54.527, lng: -3.016, ns: 'N', ew: 'W' },
    photo: 'assets/products/helvellyn_preview.png',
    blurb: 'A commission. 9 cm crop centred on Striding Edge. 1:11000.',
    spec: 'Topographic commission.',
    price: 240, stock: 3,
  },
  {
    id: 'brighton', name: 'Brighton Marina', region: 'East Sussex',
    type: 'Coast',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 50.812, lng: -0.105, ns: 'N', ew: 'W' },
    photo: 'assets/products/brighton_preview.png',
    blurb: 'A commission. 9 cm crop centred on the Marina basin. 1:11000.',
    spec: 'Coastal commission.',
    price: 240, stock: 2,
  },
  {
    id: 'lincoln', name: 'Lincoln', region: 'Lincolnshire',
    type: 'Landmark',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 53.234, lng: -0.541, ns: 'N', ew: 'W' },
    photo: 'assets/products/lincoln_preview.png',
    blurb: 'A commission. 9 cm crop centred on the cathedral cliff. 1:11000.',
    spec: 'Studio commission.',
    price: 240, stock: 2,
  },
  {
    id: 'durham', name: 'Durham', region: 'County Durham',
    type: 'Landmark',
    accent: null, landmark: null, landmarkId: null,
    coords: { lat: 54.776, lng: -1.575, ns: 'N', ew: 'W' },
    photo: 'assets/products/durham_preview.png',
    blurb: 'A commission. 9 cm crop centred on the peninsula. 1:11000.',
    spec: 'Studio commission.',
    price: 240, stock: 1,
  },
];

window.ACCENTS = {
  vermilion: { hex: '#D34833', name: 'Vermilion',  note: 'Steel furnace · civic signage' },
  cobalt:    { hex: '#2848C5', name: 'Cobalt',     note: 'Transit · tile · infrastructure' },
  saffron:   { hex: '#E8AB30', name: 'Saffron',    note: 'Brass · Bath stone · late light' },
  jade:      { hex: '#2E7960', name: 'Jade',       note: 'Parkland · river verges' },
  aubergine: { hex: '#59395F', name: 'Aubergine',  note: 'Heather · dusk · weathered stone' },
  coral:     { hex: '#ED7558', name: 'Coral',      note: 'Painted houses · harbour timber' },
};

window.LOCATIONS = [
  { q: 'S1 2HE',   label: 'Sheffield City Hall',   lat: 53.3811, lng: -1.4701 },
  { q: 'SW1A 1AA', label: 'Buckingham Palace',     lat: 51.5014, lng: -0.1419 },
  { q: 'BA2 4AT',  label: 'Roman Baths, Bath',     lat: 51.3811, lng: -2.3590 },
  { q: 'CB2 1ST',  label: 'King\u2019s Parade',    lat: 52.2043, lng:  0.1149 },
  { q: 'EH1 2NG',  label: 'Edinburgh Castle',      lat: 55.9533, lng: -3.1883 },
  { q: 'BS8 3PA',  label: 'Clifton Suspension',    lat: 51.4545, lng: -2.5879 },
  { q: 'YO22 4JR', label: 'Whitby Abbey',          lat: 54.488, lng: -0.609 },
  { q: 'M3 4LZ',   label: 'Castlefield',           lat: 53.4760, lng: -2.2550 },
  { q: 'L3 1DG',   label: 'Pier Head, Liverpool',  lat: 53.4046, lng: -2.9950 },
  { q: 'OX1 3BG',  label: 'Radcliffe Square',      lat: 51.7536, lng: -1.2543 },
  { q: 'G1 5DR',   label: 'Merchant City',         lat: 55.8580, lng: -4.2452 },
  { q: 'YO1 7HH',  label: 'York Minster',          lat: 53.9620, lng: -1.0819 },
];

window.COLLECTIONS = [
  { id: 'cities',     name: 'Cities',           n: 12, blurb: 'The twelve. City centres at 1:11000.' },
  { id: 'districts',  name: 'Neighbourhoods',   n:  2, blurb: 'The block where you live.' },
  { id: 'topography', name: 'Peaks & Edges',    n:  3, blurb: 'Summits and arêtes in pure topography.' },
  { id: 'coast',      name: 'Coast & Piers',    n:  2, blurb: 'Where the land stops.' },
  { id: 'landmarks',  name: 'Landmarks',        n:  2, blurb: 'Single buildings in their setting.' },
];

window.TYPES = ['All','City','District','Topography','Coast','Landmark'];
window.REGIONS = ['All Regions','South Yorkshire','Greater London','Somerset','Cambridgeshire','Lothian','Avon','Greater Manchester','Merseyside','Oxfordshire','Lanarkshire','North Yorkshire','Glamorgan','Sheffield','Cumbria','Derbyshire','East Sussex','Lincolnshire','County Durham'];
